module.exports = __webpack_public_path__ + "img/icon-introduction-詠馨.ac570812.png";